module.exports = __webpack_public_path__ + "img/home-2Icon@2x.2d59df29.svg";